import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { BlogArticleFragmentDoc } from '../../fragments/__generated__/BlogArticle.generated';
import { BlogFragmentDoc } from '../../fragments/__generated__/Blog.generated';
import { ProductPriceRangeFragmentDoc } from '../../fragments/__generated__/ProductPriceRange.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HomeArticlesQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
}>;


export type HomeArticlesQuery = { blogArticleList: { edges: Array<{ node: { id: string, pk: number, body: string, title: string, slug: string, authorName: string | null, dateAdded: any, annotation: string, datePublished: any | null, status: string, averageRating: number, userMeasure: number, keywords: string, tags: string, bigThumbnail: string | null, mediumThumbnail: string | null, smallThumbnail: string | null, bigThumbnailWebp: string | null, mediumThumbnailWebp: string | null, smallThumbnailWebp: string | null, categories: Array<{ id: string, blog: { id: string, pk: number, description: string, name: string, slug: string, subscribed: boolean, isWholesale: boolean, image: { url: string } } }>, author: { id: string, pk: number }, image: { url: string } } }> } };

export type HomeProductReflectionsQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  orderBy: Array<Types.ProductSiteSpecificsOrder> | Types.ProductSiteSpecificsOrder;
}>;


export type HomeProductReflectionsQuery = { specifics: { edges: Array<{ node: { id: string, pk: number, name: string, shortName: string, slug: string, product: { id: string, thumbnail: { lg: string | null, sm: string | null }, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } } } | null } }> } };


export const HomeArticlesDocument = gql`
    query HomeArticles($first: Int!) {
  blogArticleList(first: $first) {
    edges {
      node {
        ...BlogArticleFragment
        categories {
          id
          blog {
            ...BlogFragment
          }
        }
      }
    }
  }
}
    ${BlogArticleFragmentDoc}
${BlogFragmentDoc}`;

/**
 * __useHomeArticlesQuery__
 *
 * To run a query within a React component, call `useHomeArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeArticlesQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useHomeArticlesQuery(baseOptions: Apollo.QueryHookOptions<HomeArticlesQuery, HomeArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeArticlesQuery, HomeArticlesQueryVariables>(HomeArticlesDocument, options);
      }
export function useHomeArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeArticlesQuery, HomeArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeArticlesQuery, HomeArticlesQueryVariables>(HomeArticlesDocument, options);
        }
export type HomeArticlesQueryHookResult = ReturnType<typeof useHomeArticlesQuery>;
export type HomeArticlesLazyQueryHookResult = ReturnType<typeof useHomeArticlesLazyQuery>;
export type HomeArticlesQueryResult = Apollo.QueryResult<HomeArticlesQuery, HomeArticlesQueryVariables>;
export function refetchHomeArticlesQuery(variables: HomeArticlesQueryVariables) {
      return { query: HomeArticlesDocument, variables: variables }
    }
export const HomeProductReflectionsDocument = gql`
    query HomeProductReflections($first: Int!, $orderBy: [ProductSiteSpecificsOrder!]!) {
  specifics(
    first: $first
    ordering: $orderBy
    filters: {excludeSupplyParts: true}
  ) {
    edges {
      node {
        id
        pk
        name
        shortName
        slug
        product {
          id
          thumbnail {
            lg(method: THUMBNAIL_WEBP)
            sm(size: "300x0", method: THUMBNAIL_WEBP)
          }
          priceRange {
            ...ProductPriceRangeFragment
          }
        }
      }
    }
  }
}
    ${ProductPriceRangeFragmentDoc}`;

/**
 * __useHomeProductReflectionsQuery__
 *
 * To run a query within a React component, call `useHomeProductReflectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeProductReflectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeProductReflectionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useHomeProductReflectionsQuery(baseOptions: Apollo.QueryHookOptions<HomeProductReflectionsQuery, HomeProductReflectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeProductReflectionsQuery, HomeProductReflectionsQueryVariables>(HomeProductReflectionsDocument, options);
      }
export function useHomeProductReflectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeProductReflectionsQuery, HomeProductReflectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeProductReflectionsQuery, HomeProductReflectionsQueryVariables>(HomeProductReflectionsDocument, options);
        }
export type HomeProductReflectionsQueryHookResult = ReturnType<typeof useHomeProductReflectionsQuery>;
export type HomeProductReflectionsLazyQueryHookResult = ReturnType<typeof useHomeProductReflectionsLazyQuery>;
export type HomeProductReflectionsQueryResult = Apollo.QueryResult<HomeProductReflectionsQuery, HomeProductReflectionsQueryVariables>;
export function refetchHomeProductReflectionsQuery(variables: HomeProductReflectionsQueryVariables) {
      return { query: HomeProductReflectionsDocument, variables: variables }
    }